// src/components/products/ProductContainerImage.jsx
import React from "react";

/**
 * Product image with fixed or intrinsic sizing (see index.css).
 * Use sizing="intrinsic" on product detail pages; ProductCard uses fixed + card overrides.
 */
const ProductContainerImage = ({
  src,
  alt = "",
  className = "",
  onClick,
  sizing = "fixed",
}) => {
  if (!src) return null;

  const sizingClass =
    sizing === "intrinsic" ? "product-container-image--intrinsic" : "";

  return (
    <img
      src={src}
      alt={alt}
      className={`product-container-image ${sizingClass} ${className}`.trim()}
      loading="lazy"
      decoding="async"
      onClick={onClick}
    />
  );
};

export default ProductContainerImage;
